import storageUtils from '../../../util/storageUtils'

let defaultConfigure = {
  readType: 'auto',
  secure: false,
  httpPort: 8989,
  httpsPort: 9199,
  socketPort: 5000
}

let nativeConfigure = storageUtils.getItem('id-card', 'configure')

const idCardConfigure = {
  state: Object.assign(defaultConfigure, nativeConfigure)
}

export default idCardConfigure
